import { render, staticRenderFns } from "./add-merchants.vue?vue&type=template&id=26fa47a0&scoped=true&"
import script from "./add-merchants.vue?vue&type=script&lang=js&"
export * from "./add-merchants.vue?vue&type=script&lang=js&"
import style0 from "./add-merchants.vue?vue&type=style&index=0&id=26fa47a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa47a0",
  null
  
)

export default component.exports